import * as React from 'react';
import * as style from './SearchResultsEmpty.css';

export const SearchResultsEmpty: React.FC = () => {
  return (
    <div className={style['container']}>
      <div className={style['image']} />
      <div className={style['title']}>Пока нет ничего подходящего</div>
      <div className={style['description']}>Попробуйте изменить условия поиска</div>
    </div>
  );
};
